import axios from 'axios';
import Cookies from 'js-cookie';
import i18n from '@/js/i18n';

import { inMgnl, getUrlContext, getHomePageUrl } from '@/helpers/AppHelpers';
import { PageMapping } from '@/helpers/PageMappingHelpers';
import session from './compte/session';

export default {
  // Permet de gérer automatiquement la langue lors de la requête
  // nePasFermerSessionSiErrorConnexion: true|FALSE
  call(url, urlMock, method = 'GET', config = {}) {
    if (!config.params) config.params = {};
    config.params.lang = i18n.locale;
    if (!config.data) config.data = {};
    if (!config.headers || process.env.VUE_APP_IS_MOCK == 'true' || inMgnl) config.headers = {};
    if (!config.withCredentials) config.withCredentials = false;

    if (process.env.VUE_APP_IS_MOCK == 'true' || inMgnl) {
      method = 'GET';
    }

    if (/^(POST|PUT|PATCH|DELETE)$/i.test(method)) {
      config.headers['JEL-XTOKEN'] = Cookies.get('Jel-csrf');
    }

    url = urlMock ? this.getApiUrlContext(url, urlMock) : url;

    const axiosInstance = axios.create();

    axiosInstance.interceptors.response.use((response) => {
      // Traiter ici toutes les erreurs reçues d'un HTTP 200
      let { siteUrl } = PageMapping.ERREUR_GENERIQUE; // Défaut
      if (response.data && response.data.status === 'ERROR') {
        if (response.data.msg === 'CONNEXION') {
          if (!config.nePasFermerSessionSiErrorConnexion) {
            session.fermerSession();
            siteUrl = getHomePageUrl();
          }
        }
      }

      return response; // On laisse le "then" appellant pousuivre
    });

    return axiosInstance({
      url,
      method,
      params: config.params,
      data: config.data,
      responseType: 'json',
      headers: config.headers,
      withCredentials: config.withCredentials,
    });
  },

  // Appeler cette méthode dans le catch d'un api.call()
  processError(error) {
    // Traiter ici toutes les erreurs HTTP standards
    if (error.response && error.response.status === 500) {
      // Internal server error
      return 'MSG01';
    }

    if (error.response && error.response.status === 401) {
      if (error.response.message && error.response.message.indexOf('reCaptcha') != -1) {
        // 401: reCaptcha invalide
        return 'MSG99-02';
      }

      // 401: accès non autorisé
      return 'MSG99-01';
    }

    return 'MSG04';
  },

  // Retourne le bon base url + contexte en fonction de l'environnement
  // "partialPath": chemin réel. Si débute par "/" alors path absolu.
  // "partialPathMock": chemin sur mock=true ou dans l'éditeur Magnolia, sans "/"
  getApiUrlContext(partialPath, partialPathMock) {
    if (process.env.VUE_APP_IS_MOCK == 'true' || inMgnl) {
      return getUrlContext(`${process.env.VUE_APP_JEL_API}/${partialPathMock}`);
    }

    if (partialPath.charAt(0) == '/') {
      return partialPath;
    }
    // Prise en compte des appels REST via API GATEWAY
    if (
      /^(account(-api)?\/|bingo-api\/|(ce-)?(portal|intpref)\/|activity-api\/|player-api\/|promo-api\/|lots\/|payment\/)/i.test(
        partialPath
      )
    ) {
      return `${process.env.VUE_APP_FACADE_GATEWAY_URL}/${partialPath}`;
    }

    return `${process.env.VUE_APP_BASE_REST_SERVICE}/${partialPath}`;
  },
};
